import { render } from "./ButtonMulti.vue?vue&type=template&id=3d68646e&scoped=true"
import script from "./ButtonMulti.vue?vue&type=script&lang=js"
export * from "./ButtonMulti.vue?vue&type=script&lang=js"

import "./ButtonMulti.vue?vue&type=style&index=0&id=3d68646e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d68646e"]])

export default __exports__